module.exports = __webpack_public_path__ + "img/resources-1440.d65d9431.jpg";